import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button'];
  static values = {
    selected: String,
  };

  connect() {
    this.selectedValue = this.selectedValue || this.selectedValueValue;
    this.updateSelectedStyles();
  }

  select(event) {
    const value = event.currentTarget.dataset.groupButtonValue;

    this.selectedValue = value;

    this.updateSelectedStyles();

    window.dispatchEvent(
      new CustomEvent('group-button:change', {
        detail: { value },
      }),
    );
  }

  selectedValueChanged() {
    this.updateSelectedStyles()
  }

  updateSelectedStyles() {
    this.buttonTargets.forEach((button) => {
      const isSelected = button.dataset.groupButtonValue === this.selectedValue;
      button.classList.toggle('bg-black-100', isSelected);
      button.classList.toggle('bg-white', !isSelected);
      button.classList.toggle('border-black-100', isSelected);
      button.classList.toggle('border-black-50', !isSelected);
    });
  }
}
